import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import {
  initialValuesLogin,
  submitLogin,
  validationSchemaLogin,
} from "./LoginControllers";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import { ICTextInput } from "../../core-component/form";
import { eyeIcon, visibilityEyeIcon } from "../../assets/icons/SvgIconList";
import { ICButton } from "../../core-component/ui";
import ICImage from "../../core-component/ui/ICImage";
import { routePublic } from "../../routes/PublicRoutePath";

const LoginView = () => {
  const { t } = UseTranslationHook();
  const [showPassword, setShowPassword] = useState(false);
  const location = useLocation();
  const navigation = useNavigate();

  const username = location?.state?.username;

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const validationSchema = validationSchemaLogin;
  const formikInitialValues = {
    ...initialValuesLogin,
    username: username ?? "",
  };
  const formik = useFormik({
    initialValues: formikInitialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {
      formik.setSubmitting(true);
      await submitLogin(values, navigation, t);
      formik.setSubmitting(false);
    },
  });

  return (
    <div className="grid grid-cols-12">
      <div className="col-span-12 hidden md:flex md:col-span-6 lg:col-span-7 xl:col-span-8 h-svh w-full  items-center justify-center bg-base">
        <ICImage
          className="w-full "
          src={require("../../assets/image/app-logo.png")}
          alt={t("poster_image")}
        />
      </div>
      <div className="col-span-12 md:col-span-6  lg:col-span-5 xl:col-span-4 h-svh flex items-center justify-center bg-subtle">
        <div className="mx-6 sm:mx-6 md:mx-14 lg:mx-20 xl:mx-24">
          <div className="flex w-full justify-center ">
            <ICImage
              className="font-semibold text-4xl tracking-widest h-64 mb-4"
              src={require("../../assets/image/app-logo-server.jpg")}
              alt={t("poster_image")}
            />
          </div>
          <p className="font-bold text-3xl mt-4 text-center">{t("log_in")}</p>
          <p className="text-muted text-sm text-center mt-2">
            {t("personalized_dashboard")}
          </p>
          <form className="rounded py-8" onSubmit={formik.handleSubmit}>
            <div className="mb-4">
              <ICTextInput
                required
                containerClassName="p-3"
                label={t("user_name")}
                name="username"
                value={formik.values.username}
                autoFocus
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                errorMessage={
                  formik.touched.username &&
                  formik.errors.username &&
                  formik.errors.username
                }
              />
            </div>
            <div className="mb-2">
              <ICTextInput
                required
                containerClassName="p-3"
                type={showPassword ? "text" : "password"}
                label={t("Password")}
                trailing={
                  showPassword ? (
                    <div className="size-5" onClick={togglePasswordVisibility}>
                      {eyeIcon}
                    </div>
                  ) : (
                    <div className="size-5" onClick={togglePasswordVisibility}>
                      {visibilityEyeIcon}
                    </div>
                  )
                }
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                errorMessage={
                  formik.touched.password &&
                  formik.errors.password &&
                  formik.errors.password
                }
              />
            </div>

            <div
              className="text-accent text-sm cursor-pointer"
              onClick={() => {
                navigation("/" + routePublic.forgotPassword);
              }}
            >
              {t("forgot_password")}?
            </div>
            <div className="items-center justify-center mt-6">
              <ICButton
                className="w-full"
                type="submit"
                children={t("log_in")}
                loading={formik.isSubmitting}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default LoginView;
